import { Close } from "@mui/icons-material";
import { Alert, Box, Button, Dialog, DialogContent, DialogTitle, IconButton, Portal, useMediaQuery, useTheme } from "@mui/material";
import { FC, useState } from "react";
import { getUserNotifications, UserNotification } from "src/apis/user";
import ErrorAlert from "./ErrorAlert";
import NotificationCard from "./NotificationCard";

type NotificationsDialogProps = {
  isOpen: boolean,
  setIsOpen: (isOpen: boolean) => void;
  onReadSuccess?: (notification: UserNotification) => void;
}

const NotificationsDialog: FC<NotificationsDialogProps> = ({isOpen, setIsOpen, onReadSuccess = () => {}}): JSX.Element => {
  const [userNotifications, setUserNotifications] = useState<UserNotification[]>([]);
  const [error, setError] = useState<string>('');
  const [page, setPage] = useState<number>(1);

  const theme = useTheme();
  const fullscreen = useMediaQuery(theme.breakpoints.down('sm'))

  const resetState = () => {
    setUserNotifications([]);
    setError('');
    setPage(1);
  }

  const fetchUserNotifications = async () => {
    try {
      const res = await getUserNotifications(page);
      const notifications: UserNotification[] = [...userNotifications, ...res];
      const seen: number[] = [];
      const deduplicatedNotifications = notifications.filter((userNotification: UserNotification) => {
        const alreadySeen = seen.includes(userNotification.user_notification_id);
        if (alreadySeen) {
          return false;
        }

        seen.push(userNotification.user_notification_id);
        return true;
      })


      setUserNotifications(deduplicatedNotifications);
      setError('')
    } catch (e: any) {
      setError("Falha ao obter as notificações")
    }
  }

  return (
    <Portal>
      <Dialog
        fullWidth
        maxWidth="md"
        fullScreen={fullscreen}
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
          resetState();
        }}
        TransitionProps={{
          onEntered: (_, isAppearing) => {
            if (isAppearing) {
              fetchUserNotifications();
            }
          }
        }}
      >
        <DialogTitle>
          Notificações

          <IconButton
            aria-label="close"
            onClick={() => {
              setIsOpen(false);
              resetState();
            }}
            sx={(theme) => ({
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          {Boolean(error) ? (
            <ErrorAlert fill error={error} />
          ) : (
            <>
              {userNotifications.length >= 1 ? (
                <Box sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5em"
                }}>
                  {userNotifications?.map((userNotification: UserNotification) => (
                    <NotificationCard
                      notification={userNotification}
                      setError={setError}
                      onReadSuccess={onReadSuccess}
                    />
                  ))}

                  {userNotifications.length >= 25 && (
                    <Button
                      variant="contained"
                      sx={{
                        width: '100%',
                      }}
                      onClick={() => {
                        setPage(page + 1);
                        fetchUserNotifications();
                      }}
                    >
                      Carregar mais notificações
                    </Button>
                  )}
                </Box>
              ) : (
                <Box
                  sx={{
                    width: "100%",
                  }}
                >
                  <Alert
                    severity="info" sx={{
                      maxWidth: "50%",
                      margin: "auto",
                    }}
                  >
                    Sem notificações
                  </Alert>
                </Box>
              )}
            </>
          )}
        </DialogContent>
      </Dialog>
    </Portal>
  );
}

export default NotificationsDialog;

